module.exports = __webpack_public_path__ + "img/horse.b7b25e23.svg";